import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Справочник содержит различные отступы от стен транспорта.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, " Изначально в справочник добавлены варианты с отступом от стен транспорта в 5см, 10см и 0см ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Отступы",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }, 512))
}